import { useEffect, useMemo } from 'react'

import { useBrandRanking } from 'contexts/BrandRankingContext'
import { useZaiChat } from 'contexts/ZaiChatContext'
import { analyticsTracker } from 'utils'

import type { IZaiChatMobilePage } from './zai-chat-mobile-page.types'

export function useZaiChatMobilePageModel(): IZaiChatMobilePage {
  const { askQuestion, questions } = useZaiChat()
  const { brands, isLoading, error, workspaceCategory } = useBrandRanking()

  const questionsWithOptions = useMemo(
    () => [
      {
        text: questions.whatIsSoa,
      },
      {
        text: questions.isItGood,
      },
      {
        text: questions.howToIncreasePosition,
        isFakeDoor: true,
      },
      {
        text: questions.whatInsightsDaily,
      },
      {
        text: questions.whichPlatformToImprove,
        isFakeDoor: true,
      },
    ],
    [questions]
  )
  const questionsList = useMemo(() => questionsWithOptions.map(item => item.text), [questionsWithOptions])

  function onZaiQuestionClick(question: string) {
    const selectedQuestionIndex = questionsList.findIndex(item => item === question)
    const hasFakeDoor = questionsWithOptions?.[selectedQuestionIndex]?.isFakeDoor

    askQuestion(question, {
      brands,
      hasFakeDoor,
      mixpanelProps: {
        Page: 'Zai Mobile',
        Question: question,
        'Chart Title': 'ZAI mobile',
      },
    })
  }

  useEffect(() => {
    const { CAT } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(CAT.OPEN_MOBILE_ZAI, {
      Page: 'Zai Mobile',
    })
  }, [])

  return {
    questionsList,
    onZaiQuestionClick,
    isLoading,
    error,
    workspaceCategory: workspaceCategory.id,
  }
}
